<template>
  <div id="contenedor-agregar-nuevo-participante-licitaciones">
    <v-form
      v-model="formularioValido"
      ref="agregarNuevoParticipanteLicitaciones"
    >
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Nuevo Participante
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-autocomplete
              cols="12"
              v-model="licitacionParticipante.idContratista"
              label="Seleccionar Participante"
              :items="contratistas"
              item-text="nombreRazonSocial"
              item-value="id"
              clearable
              :rules="[mixReglas.requerido]"
            >
            </custom-autocomplete>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixAgregarLicitacionParticipante"
            :disabled="!formularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixParticipantes from './mixParticipantes';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarNuevoParticipanteLicitaciones',
  mixins: [mixParticipantes],
  props: {
    idLicitacion: String,
  },
  components: {
    CustomAutocomplete,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      licitacionParticipante: {
        idContratista: null,
        idLicitacion: this.idLicitacion,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarNuevoParticipanteLicitaciones.reset();
    },
  },
};
</script>

<style>
</style>
